/**
 * Минимальный набор полей клика, нужный правилу перехвата. Не завязан на
 * DOM или React: в кабинете нет jsdom и @testing-library, поэтому правило
 * проверяется юнит-тестом на голых объектах, без рендера компонента.
 */
export interface TitleLinkClickEvent {
  defaultPrevented: boolean;
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  stopPropagation: () => void;
  preventDefault: () => void;
}

/**
 * Правило перехвата клика по названию элемента в списках партнёрского
 * кабинета. Идиома из cabinet/src/admin/features/translations/editor/
 * TranslationEditor.tsx (handleLinkClick): обычный левый клик без
 * модификаторов открывает карточку программно поверх списка, без
 * перезагрузки страницы. Клик не левой кнопкой мыши, с зажатым meta, ctrl,
 * shift или alt, либо уже отменённый кем-то выше, не перехватываем и
 * отдаём браузеру: он сам откроет ссылку, в том числе в новой вкладке.
 *
 * Всплытие клика гасится всегда и до всех проверок, иначе сработает
 * обработчик клика на всей карточке или строке списка, и карточка
 * элемента откроется дважды или откроется не та.
 */
export function handleTitleLinkClick(
  event: TitleLinkClickEvent,
  onOpen: () => void
): void {
  event.stopPropagation();

  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  event.preventDefault();
  onOpen();
}
